enum PARTICIPANT_STATUS {
  INVITED = "INVITED",
  INPROGESS = "INPROGRESS",
  COMPLETED = "COMPLETED",
  PAID = "PAID",
}
export default PARTICIPANT_STATUS;
